export const needsProfileCompletion = (user) => {
  if (!user) return false;

  const hasFirmOrCompany = typeof user.name === "string" && user.name.trim().length > 0;
  const hasRole = typeof user.role === "string" && user.role.trim().length > 0;

  return !hasFirmOrCompany || !hasRole;
};
